export const levelValues = {
  secondary: 'Среднее профессиональное образование',
  higher: 'Высшее образование'
}
